import HeadingWrapperView from "../view/heading-wrapper.js";
import HeadingWrapperModel from "../model/heading-wrapper.js";

import {
  defaultHeadingWrapperModelData,
  ActionType
} from "../../const.js";

import {
  removeElement,
  render
} from "../../../render/render.js";

export default class HeadingWrapper {
  constructor(element, animation, changeFilter) {
    this._element = element;
    this._animation = animation;
    this._changeFilter = changeFilter;

    this._view = null;
    this._model = null;

    this._handleChangeFilterLoad = this._handleChangeFilterLoad.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
  }

  init() {
    this._view = new HeadingWrapperView(this._element);
    this._model = new HeadingWrapperModel(Object.assign(
        {},
        defaultHeadingWrapperModelData,
        {
          isTotalRendered: (this._view.getTotalElement()) ? true : false,
          total: (this._view.getElement()) ?
            this._view.getTotal() :
            0
        }
    ));

    this._changeFilter.addLoadObserver(this._handleChangeFilterLoad);
    this._model.addObserver(this._handleChangeData);
  }

  _processShowTotal() {
    const totalElement = this._view.createTotalElement(this._model.getData().total);
    render(this._view.getHeadingElement(), totalElement);

    this._animation.fadeIn(
        this._view.getTotalElement(),
        null,
        () => {
          this._view.makeTotalVisible();
        }
    );
  }

  _processHideTotal() {
    const totalElement = this._view.getTotalElement();
    this._view.unsetTotalElement();

    this._animation.fadeOut(
        totalElement,
        null,
        () => {
          removeElement(totalElement);
        }
    );
  }

  _processChangeTotal() {
    this._view.changeTotal(this._model.getData().total);
  }

  _handleChangeFilterLoad(data) {
    if (
      data.total > 0 &&
      data.total !== this._model.getData().total &&
      this._model.getData().isTotalRendered
    ) {
      this._model.changeData(Object.assign(
          {},
          this._model.getData(),
          {
            total: data.total
          }
      ), ActionType.CHANGE_TOTAL);
      return;
    }

    if (data.total > 0 && !this._model.getData().isTotalRendered) {
      this._model.changeData(Object.assign(
          {},
          this._model.getData(),
          {
            isTotalRendered: true,
            total: data.total
          }
      ), ActionType.SHOW_TOTAL);
      return;
    }

    if (data.total === 0 && this._model.getData().isTotalRendered) {
      this._model.changeData(Object.assign(
          {},
          this._model.getData(),
          {
            isTotalRendered: false,
            total: data.total
          }
      ), ActionType.HIDE_TOTAL);
      return;
    }
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.SHOW_TOTAL:
        this._processShowTotal();
        break;
      case ActionType.HIDE_TOTAL:
        this._processHideTotal();
        break;
      case ActionType.CHANGE_TOTAL:
        this._processChangeTotal();
        break;
    }
  }
}
